const getFeedbackByState = (feedbacks, status) => {
	// Cancelled feedbacks are also shown in the submitted tab
	if (status === 'SUBMITTED') {
		return feedbacks
			.filter(
				(feedback) =>
					feedback.feedbackRequestStatus === 'CANCELLED' || feedback.feedbackState === status,
			)
			.slice()
			.sort((a, b) => new Date(b.requestedOn) - new Date(a.requestedOn));
	}

	return feedbacks
		.filter(
			(feedback) =>
				feedback.feedbackRequestStatus !== 'CANCELLED' && feedback.feedbackState === status,
		)
		.slice()
		.sort((a, b) => new Date(b.requestedOn) - new Date(a.requestedOn));
};

const isDisabled = ({ feedbackState, permissions, feedbackRequestStatus }) => {
	if (feedbackRequestStatus === 'CANCELLED') {
		return true;
	}
	if (feedbackState === 'SUBMITTED') {
		return false;
	}
	return permissions === 'ro';
};

export const getOrderedDashboardFeedbacks = (feedbacks) => {
	const updatedFeedbacks = feedbacks.map((feedback) => ({
		...feedback,
		disabled: isDisabled(feedback),
	}));
	const notStarted = getFeedbackByState(updatedFeedbacks, 'NOT_STARTED');
	const inProgress = getFeedbackByState(updatedFeedbacks, 'IN_PROGRESS');
	const completed = getFeedbackByState(updatedFeedbacks, 'SUBMITTED');

	return {
		notStarted,
		inProgress,
		completed,
	};
};

export const getFeedbackWithInitialResponse = (feedback) => {
	if (feedback.hideFeedbackForm) {
		return {
			...feedback,
			initialResponses: [],
			requiredQuestions: [],
			cardDetails: {
				feedbackState: '',
				formNames: '',
			},
		};
	}

	const initialResponses = feedback.formCard.body
		.filter(({ type }) => type !== 'TextBlock')
		.map(({ id, value }) => ({
			id,
			value: value || '',
		}));
	const requiredQuestions = [];
	feedback.formCard.body.forEach(({ id, isRequired }) => {
		if (isRequired) {
			requiredQuestions.push(id);
		}
	});
	return {
		...feedback,
		cardDetails: { ...feedback.cardDetails, intervieweeId: feedback.cardDetails.candidateId },
		initialResponses,
		requiredQuestions,
	};
};

export const getSubmitDataPayload = ({ responses, feedbackState, feedbackRequestId }) => {
	const parsedReponses = {};
	responses.forEach(({ id, value }) => {
		parsedReponses[id] = value;
	});
	return {
		...parsedReponses,
		feedbackRequestId,
		feedbackState,
	};
};

export const determineErrorMessageWhenRetrievingForm = (isError, feedbackError, t) => {
	if (isError) {
		try {
			if (
				feedbackError?.response?.data?.includes(
					'Ratings and Recommendations feature is not enabled',
				)
			) {
				return t('form_unavailable_error_text');
			}
		} catch (e) {
			return t('error_text');
		}
		return t('error_text');
	}
	return null;
};

export const getCount = (obj, property) => (obj[property] ? obj[property].length : 0);

export const getCompleteCount = (obj, property) => {
	let completedCount = 0;
	let canceledCount = 0;

	if (obj[property]) {
		completedCount = obj[property].filter(
			(item) => item.feedbackRequestStatus !== 'CANCELLED',
		).length;
		canceledCount = obj[property].filter(
			(item) => item.feedbackRequestStatus === 'CANCELLED',
		).length;
	}
	return { completedCount, canceledCount };
};
